import { SpectrumColor } from '../types';

export const Flamingo: SpectrumColor = {
  0: '#FFF7F3',
  5: '#FFF2EC',
  10: '#FFEADF',
  15: '#FFE2D3',
  20: '#FFD9C7',
  25: '#FFC8AD',
  30: '#FFB793',
  35: '#FFA071',
  40: '#FF894E',
  50: '#FF742E',
  60: '#FF5500',
  70: '#D44700',
  80: '#B23B00',
  90: '#923100',
  100: '#732600',
  110: '#501B00',
  default: 60,
};
